//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ObjectsCarouselFuturesCategories from "@/components/objects/CarouselFuturesCategories.vue";
import { STORAGE_IMAGE_PATH } from "@/constants/ui.js";
import ObjectSnippet from "@/components/objects/ObjectSnippet.vue";
import MainShowMoreBtn from '@/components/MainShowMoreBtn.vue';

const PAGE_SIZE = 12

export default {
  name: "MainObjects",
  components: { ObjectSnippet, ObjectsCarouselFuturesCategories, MainShowMoreBtn },

  props: {
    categoryId: {
      type: [Number, String],
      default: null,
    },
    categoryPage: {
      type: Boolean,
      default: false,
    },
    objectsOrder: {
      type: String,
      default: '-total_score',
    },
    categorySubtree: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      slicedObjects: [],
      topList: [],
      bottomList: [],
      objectsViewCount: 4,
      swapedBtnToLink: false,
      loadingMore: false,
      imagePath: [`${STORAGE_IMAGE_PATH}$id`, 'cover'],
    }
  },

  computed: {
    mainObjects() {
      return this.$store.getters['objects/getMainObjects'];
    },
    mainObjectsTotal() {
      return this.$store.getters['objects/getMainObjectsTotal'];
    },
    showMoreBtn() {
      if (!this.categoryPage) {
        return true
      }
      const total = this.mainObjectsTotal || this.mainObjects.length
      return this.slicedObjects.length < total
    },
  },

  watch: {
    slicedObjects(newVal) {
      this.topList = newVal.slice(0, this.objectsViewCount / 2)
      this.bottomList = newVal.slice(this.objectsViewCount / 2)
    },

    objectsViewCount(newVal) {
      this.slicedObjects = this.mainObjects.slice(0, newVal)

      this.swapedBtnToLink = false
    },

    mainObjects() {
      if (this.categoryPage && this.slicedObjects.length) {
        this.syncSlicedObjects()
      }
    },
  },

  created() {
    this.slicedObjects = this.mainObjects.slice(0, this.objectsViewCount)
  },

  mounted() {
    this.updateObjectsViewCount()
    this.slicedObjects = this.mainObjects.slice(0, this.objectsViewCount)

    window.addEventListener('resize', this.updateObjectsViewCount, { passive: true })
  },

  destroyed() {
    window.removeEventListener('resize', this.updateObjectsViewCount)
  },

  methods: {
    updateObjectsViewCount() {
      if (typeof window !== "undefined") {
        if (window.innerWidth >= 1600) {
          this.objectsViewCount = 8
        } else if (window.innerWidth >= 1200) {
          this.objectsViewCount = 8
        } else if (window.innerWidth >= 640) {
          this.objectsViewCount = 4
        } else {
          this.objectsViewCount = 6
        }
      }
    },

    getShowMoreIncrement() {
      return window.innerWidth < 640 ? 3 : this.objectsViewCount / 2
    },

    syncSlicedObjects() {
      const increment = this.getShowMoreIncrement()
      const nextCount = Math.min(
        this.slicedObjects.length + this.objectsViewCount + increment,
        this.mainObjects.length
      )
      this.slicedObjects = this.mainObjects.slice(0, nextCount)
    },

    async addMoreObjects() {
      if (this.categoryPage) {
        await this.addMoreObjectsCategoryPage()
        return
      }

      this.slicedObjects = this.mainObjects.slice(0, this.objectsViewCount + this.getShowMoreIncrement())
      this.swapedBtnToLink = true
    },

    async addMoreObjectsCategoryPage() {
      const increment = this.getShowMoreIncrement()
      const nextLocalCount = Math.min(
        this.slicedObjects.length + this.objectsViewCount + increment,
        this.mainObjects.length
      )

      if (nextLocalCount > this.slicedObjects.length) {
        this.slicedObjects = this.mainObjects.slice(0, nextLocalCount)
        return
      }

      const total = this.mainObjectsTotal || this.mainObjects.length
      if (this.mainObjects.length >= total) {
        return
      }

      this.loadingMore = true
      try {
        await this.$store.dispatch('objects/getMainObjects', {
          category: this.categoryId,
          limit: PAGE_SIZE,
          offset: this.mainObjects.length,
          order: this.objectsOrder,
          category_subtree: this.categorySubtree,
        })
        this.syncSlicedObjects()
      } finally {
        this.loadingMore = false
      }
    },
  }
}
